import AppRoutes from './Routes';
import {BrowserRouter} from "react-router-dom";
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import AppAlerts from './Components/NotifyAlert';
import { ThemeProvider } from './context/ThemeContext';
import SkeletonThemeProvider from './Components/skeletons/SkeletonThemeProvider';

const App = () => {

  const profile_state = useSelector(state => state.userDetails);

  useEffect(() => {
      if (profile_state.permissions.length > 0) {
          localStorage.setItem('permissions', profile_state.permissions);
      }
  }, [profile_state.permissions])
  
  return (
    // ThemeProvider sets [data-theme] on <html> and persists to localStorage.
    // It wraps everything so all components can read/change the active theme.
    <ThemeProvider>
      <SkeletonThemeProvider>
        <BrowserRouter>
          <AppAlerts/>
          <AppRoutes />
        </BrowserRouter>
      </SkeletonThemeProvider>
    </ThemeProvider>
  );
}

export default App;
